import { render, staticRenderFns } from "./EncounterStatistics.vue?vue&type=template&id=09642d6c&scoped=true&"
import script from "./EncounterStatistics.vue?vue&type=script&lang=js&"
export * from "./EncounterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EncounterStatistics.vue?vue&type=style&index=0&id=09642d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09642d6c",
  null
  
)

export default component.exports